export const RATE_STORAGE_KEY = "ax_amp_rate"
export const AUTH_STORAGE_KEY = "ax_amp_auth"
export const AUTH_STORAGE_KEY_PID = "ax_amp_auth_pid"
export const AUTH_STORAGE_KEY_EMAIL = "ax_amp_auth_email"
export const ATTENDANCE_STORAGE_KEY = "ax_amp_attendance"

export const WHEEL_FORTUNE_PRIZE_MAP = {
    ozonGiftCertificate: 'ozonGiftCertificate',
    simpleWineGiftCertificate: 'simpleWineGiftCertificate',
    tgStickerPack: 'tgStickerPack',
    yaPlus: 'yaPlus',
    loadAndShipBonus: 'loadAndShipBonus',
}

export const WHEEL_FORTUNE_PRIZES = [
    WHEEL_FORTUNE_PRIZE_MAP.ozonGiftCertificate,
    WHEEL_FORTUNE_PRIZE_MAP.simpleWineGiftCertificate,
    WHEEL_FORTUNE_PRIZE_MAP.tgStickerPack,
    WHEEL_FORTUNE_PRIZE_MAP.yaPlus,
    WHEEL_FORTUNE_PRIZE_MAP.simpleWineGiftCertificate,
    WHEEL_FORTUNE_PRIZE_MAP.tgStickerPack,
    WHEEL_FORTUNE_PRIZE_MAP.loadAndShipBonus,
    WHEEL_FORTUNE_PRIZE_MAP.tgStickerPack
]


// WEBPACK FOOTER //
// ./src/templates/pages/axoft-maximum-pro/consts/amp.js